import React from "react";
import { pathOr } from "ramda";

import CommonTable from "../../../../components/commonTable";
import "./styles.scss";

const DataTable = (props) => {
  const {
    data,
    columns,
    fileName,
    label,
    getSuggestions,
    fetchTableData,
    count,
    rowSelection,
    selected,
    clearSelection,
    refresh,
    loading,
  } = props;
  return (
    <div className={`${selected !== undefined && "preview"}`}>
      <CommonTable
        initialCount={count}
        initialData={data}
        title={() => `${fileName}`}
        columns={columns}
        fetchData={fetchTableData}
        getSuggestions={getSuggestions}
        scroll={{ y: 431 }}
        className="data-table-content"
        rowSelection={rowSelection}
        label={label || "items"}
        rowKey={(row) =>
          row["id"] || row[pathOr("CellPhone", [0, "dataIndex"], columns)]
        }
        selected={selected}
        clearSelection={clearSelection}
        refresh={refresh}
        loading={loading}
      />
    </div>
  );
};
export default DataTable;
